import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';

import { environment } from '@orderna/admin-panel/src/environments/environment';
import { Plan } from '../../model/subscription-plan-admin';
import {
  mapDtoToPlanOptions,
} from '../mapper/subscription-plan.mapper';
import { IPlansApiService } from './plans-api.interface';
import { SubscriptionPlanOption } from '../../model/subscription-plan-option';
import { SuccessResponse } from '../shared/success-response';
import { CreatePlanData } from './dtos/create-plan-data';
import { UpdatePlanData } from './dtos/update-plan-data';
import { FindPlansResponseDto } from './dtos/find-plans.response.dto';
import { FindPlansQueryDto } from './dtos/find-plans.query.dto';
import { FindPlanResponseDto } from './dtos/find-plan.response.dto';

let API_URL = `${environment.api}`; // TODO: Include /plans

@Injectable({
  providedIn: 'root',
})
export class PlansApiService implements IPlansApiService {
  private http = inject(HttpClient);

  async findPlans(query: FindPlansQueryDto): Promise<FindPlansResponseDto> {
    const params = new HttpParams({ fromObject: query as any });
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindPlansResponseDto>>(`${API_URL}/plans`, {
        params,
      })
    );

    return response.data;
  }

  async findPlanNames(): Promise<SubscriptionPlanOption[]> {
    const response = await firstValueFrom(
      this.http.get<SuccessResponse>(`${API_URL}/plans/names`)
    );

    return mapDtoToPlanOptions(response.data);
  }

  async findPlan(planId: number): Promise<FindPlanResponseDto> {
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindPlanResponseDto>>(
        `${API_URL}/plans/${planId}`
      )
    );
    return response.data;
  }

  createPlan(plan: CreatePlanData): Observable<any> {
    return this.http.post(`${API_URL}/plans`, JSON.stringify(plan));
  }

  updatePlan(planId: number, plan: UpdatePlanData): Observable<any> {
    return this.http.patch(`${API_URL}/plans/${planId}`, JSON.stringify(plan));
  }

  deletePlan(planId: Plan['id']): Observable<any> {
    return this.http.delete(`${API_URL}/plans/${planId}`);
  }

  deletePlans(planIds: any): Observable<any> {
    return this.http.delete(`${API_URL}/plans/delete-many`, {
      body: { planIds },
    });
  }
}
